// extracted by mini-css-extract-plugin
export var content = "EducationSectionWithList-module--content--a8dfe";
export var contentItem = "EducationSectionWithList-module--contentItem--d1bcf";
export var featureImage = "EducationSectionWithList-module--featureImage--7e9fd";
export var listHolder = "EducationSectionWithList-module--listHolder--c5f2f";
export var listWrapper = "EducationSectionWithList-module--listWrapper--ee7ba";
export var title = "EducationSectionWithList-module--title--09093";
export var wrapper = "EducationSectionWithList-module--wrapper--a0e82";